import { css } from "styled-components";
import { media } from "./constants";
import { contentHeaderStyles } from "./text";

export const padding = {
  base: "2rem",
  mobileLg: "3rem",
  tabletSm: "3.5rem",
  tabletMd: "4.5rem",
  laptop: "5rem",
  laptopMd: "6rem",
};

export const commonStyles = css`
  margin: 0 auto;
  ${contentHeaderStyles}
`;

export const sectionPadding = css`
  padding: 4rem 1.5rem;

  @media (min-width: ${media.tabletSm}px) {
    padding: 7rem 3rem;
  }

  @media (min-width: ${media.tabletLg}px) {
    padding: 8rem 3rem;
  }
`;

export default css`
  ${commonStyles};
  padding: ${padding.base};

  @media (min-width: ${media.mobileLg}px) {
    padding: ${padding.mobileLg};
  }

  @media (min-width: ${media.tabletSm}px) {
    padding: ${padding.tabletSm};
  }

  @media (min-width: ${media.tabletMd}px) {
    padding: ${padding.tabletMd};
  }

  @media (min-width: ${media.laptop}px) {
    max-width: 1140px;
    padding: ${padding.laptop};
  }
`;
